import { RentalAdvert, SaleAdvert } from "../../../types/types";
import * as React from "react"

type Props = { advert: RentalAdvert | SaleAdvert }

export default (props: Props) : JSX.Element => (
  props.advert.youtubeUrl ?
    <>
      <div className="content-part">
        <h3>
          {I18n.t('rental_adverts.tabs.video')}
        </h3>
        <iframe allowFullScreen className="youtube" frameBorder="0" height="315" src={props.advert.youtubeUrl} width="560">`</iframe>
      </div>
      <hr />
    </>
  : <></>
)
